import { ITEMS_TYPES } from "./itemsTypes";
import { convertToObjById } from "helpers/convertToObject";

const {
    GET_ITEMS,
    NEW_ITEM,
    CLEAN_ITEM,
    REQUEST_ITEM,
    REQUEST_ITEM_STATIONS,
    GET_STATIONS,
    EDIT_PRICE,
    OPEN_MODAL_TO_UPDATE,
    REMOVE_ITEMS_TO_UPDATE,
    SAVE_ITEMS_TO_UPDATE,
    CLOSE_MODAL_ITEM,
    CLOSE_EDIT,
    SET_SNACKBAR,
    RESET_SNACKBAR,
    CLEAR_ITEMS_UPDATE,
    SET_CONFIG_FILTERED_ITEMS,
    SET_CONFIG_PAGE_ITEMS,
    SET_CONFIG_PAGE_ITEMS_COUNT,
    SET_CONFIG_SORTED_ITEMS,
    SET_CONFIG_PAGE_ITEM_STATIONS,
    SET_CONFIG_PAGE_ITEM_STATIONS_COUNT,
    SET_CONFIG_FILTERED_ITEM_STATIONS,
    SET_CONFIG_SORTED_ITEM_STATIONS,
    SAVE_ORIGINAL_ITEM_TO_UPDATE,
} = ITEMS_TYPES

const initialState = {
    loadingItems: false,
    items: [],
    originalItems: [],
    item: {},
    search: "",
    updateItems: [],
    stations: [],
    idStation: '',
    newItemMode: false,
    modalEdit: false,
    modal: false,
    snackbar: {
        isOpen: false,
        message: '',
        color: 'danger'
    },
    config: {
        pageSize: 15,
        page: 0,
        sorted: [],
        filtered: [],
    },
    configStations: {
        pageSize: 5,
        page: 0,
        sorted: [],
        filtered: [],
    },
}

export const itemsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case REQUEST_ITEM_STATIONS:
            return {
                ...state,
                modal: true,
                loadingItems: true,
            }
        case REQUEST_ITEM:
            return {
                ...state,
                loadingItems: true,
            }
        case GET_ITEMS:
            return {
                ...state,
                items: payload.resp,
                search: payload.search
            }
        case NEW_ITEM:
            return {
                ...state,
                newItemMode: true,
            }
        case CLEAN_ITEM:
            return {
                ...state, item: {},
            }
        case GET_STATIONS:
            return {
                ...state,
                loadingItems: false,
                item: {
                    ...payload,
                    organizations: convertToObjById(payload.organizations, "station"),
                },
                stations: payload.organizations,
            }
        case EDIT_PRICE:
            return {
                ...state,
                newItemMode: false,
                modalEdit: true,
                idStation: payload,
            }
        case OPEN_MODAL_TO_UPDATE:
            return {
                ...state,
                newItemMode: false,
                modalEdit: true,
                item: {}
            }
        case REMOVE_ITEMS_TO_UPDATE:
            return {
                ...state,
                updateItems: Object.values(state.updateItems).filter(value => value.itemNumber !== payload),
                originalItems: Object.values(state.originalItems).filter(value => value.itemNumber !== payload),
            }
        case SAVE_ITEMS_TO_UPDATE:
            return {
                ...state,
                updateItems: payload,
            }
        case CLEAR_ITEMS_UPDATE:
            return {
                ...state,
                loadingItems: false,
                updateItems: []
            }
        case SAVE_ORIGINAL_ITEM_TO_UPDATE: 
            return{
                ...state,
                originalItems: [...state.originalItems, payload]
            }
        case CLOSE_EDIT:
            return {
                ...state,
                modalEdit: false,
            }
        case CLOSE_MODAL_ITEM:
            return {
                ...state,
                modal: false
            }
        case SET_SNACKBAR:
            return {
                ...state,
                snackbar: {
                    isOpen: true,
                    color: payload.color,
                    message: payload.message
                }
            }
        case RESET_SNACKBAR:
            return {
                ...state,
                snackbar: {
                    isOpen: false,
                    message: ''
                }
            }
        case SET_CONFIG_FILTERED_ITEMS:
            return {
                ...state,
                config: {
                    ...state.config,
                    filtered: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_PAGE_ITEMS:
            return {
                ...state,
                config: {
                    ...state.config,
                    page: payload,
                },
            };

        case SET_CONFIG_PAGE_ITEMS_COUNT:
            return {
                ...state,
                config: {
                    ...state.config,
                    pageSize: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_SORTED_ITEMS:
            return {
                ...state,
                config: {
                    ...state.config,
                    sorted: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_PAGE_ITEM_STATIONS:
            return {
                ...state,
                configStations: {
                    ...state.configStations,
                    page: payload,
                },
            };
        case SET_CONFIG_PAGE_ITEM_STATIONS_COUNT:
            return {
                ...state,
                configStations: {
                    ...state.configStations,
                    pageSize: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_FILTERED_ITEM_STATIONS:
            return {
                ...state,
                configStations: {
                    ...state.configStations,
                    filtered: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_SORTED_ITEM_STATIONS:
            return {
                ...state,
                configStations: {
                    ...state.configStations,
                    sorted: payload,
                    page: 0,
                },
            };
        default: return state
    }
}